/**
 * `<img>` 的 error 事件拿不到 HTTP 状态码；对可 CORS 的资源用 fetch 探测一次（失败则视为未知）。
 */
function isSamePageOrigin(url: string): boolean {
  if (typeof window === 'undefined') return false
  try {
    const u = new URL(url.startsWith('//') ? `${window.location.protocol}${url}` : url)
    return u.origin === window.location.origin
  } catch {
    return false
  }
}

export async function probeImageHttpStatus(url: string): Promise<number | undefined> {
  const u = url.trim()
  if (!u || !/^https?:\/\//i.test(u)) return undefined
  if (!isSamePageOrigin(u)) {
    return undefined
  }

  try {
    const head = await fetch(u, { method: 'HEAD', mode: 'cors', cache: 'no-store' })
    return head.status
  } catch {
    /* CDN 可能不支持 HEAD */
  }

  try {
    const get = await fetch(u, { method: 'GET', mode: 'cors', cache: 'no-store' })
    return get.status
  } catch {
    return undefined
  }
}
